export default __webpack_public_path__ + "static/media/logo-courts-of-denmark2.48ba183a.svg";